import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetLargeClaimDetails = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_LARGE_CLAIM_DETAILS, token);
  return res;
};

export const GetLargeClaimDetail = async (largeId) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GET_LARGE_CLAIM_DETAILS_BY_ID + largeId,
    token
  );
  return res;
};

export const AddLargeClaim = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_LARGE_CLAIM, payload, token);
  return res;
};

export const DeleteLargeClaim = async (largeId) => {
  const token = localStorage.getItem("token");
  let res = await Services.DELETE(
    Url.DELETE_LARGE_CLAIM + largeId,
    largeId,
    token
  );
  return res;
};

export const UpdateLargeClaim = async (largeId, payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.PUT(
    Url.UPDATE_LARGE_CLAIM + largeId,
    payload,
    token
  );
  return res;
};
